import { faker } from '@faker-js/faker'

import { getUserTreatment } from './UserTreatment'

import { UserTreatmentTagRelation } from '../../contracts/treatment'
import { SupernovaResponse } from '../../foundation'
import { asBuilder } from '../asBuilder'

export const getUserTreatmentConcern = asBuilder<SupernovaResponse<UserTreatmentTagRelation[]>>(
  (): SupernovaResponse<UserTreatmentTagRelation[]> => {
    return {
      timestamp: new Date().toISOString(),
      status: 200,
      message: 'success',
      body: faker.helpers.multiple(
        () => ({
          srcTag: getUserTreatment(),
          destTagList: [getUserTreatment(), getUserTreatment()],
        }),
        { count: 2 },
      ),
    }
  },
)
